import React from 'react'
import { useParams } from 'react-router-dom'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import DestinationDetailsMain from '../Components/Destination/DestinationDetailsMain'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import Posts from '../Components/data/data-destination.json'

function DestinationDetails() {
    const { id } = useParams();
    const destination = Posts.find((post) => post.id === parseInt(id, 10));
    const breadcrumbTitle = destination ? destination.title : 'Tour Details';

    return (
        <>
            <HeaderOne />
            <Breadcrumb
                title={breadcrumbTitle}
            />
            <DestinationDetailsMain />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default DestinationDetails
